import { customTextBlock } from "./customTextBlock.js";
import { customExtraBlock } from "./customExtraBlock.js";
import { customLinkBlock } from "./customLinkBlock/customLinkBlock.js";
import { customTraits } from "./customLinkBlock/customTraits.js";
import ActiveExtraHover from "../../images/active_other_tools_new_icon.svg";
import InActiveExtraIcon from "../../images/default_other_tools_new_icon.svg";
import { customImageBlock } from "./customImageBlock/customImageBlock.js";
import { customTableBlock } from "./customTableBlock/customTableBlock.js";
import { customPopupBlock } from "./customPopup/customPopupBlock.js";
import TextIconHover from "../../images/active-text-new-icon.svg";
import VideoIcon from "../../images/Video_Inactive.svg";
import VideoIconHover from "../../images/Video_Active.svg";
import StructureHover from "../../images/hover_structure_new_icon.svg";
import ImageIconHover from "../../images/hover_image_new_icon.svg";
import ButtonDefault from "../../images/default_button_new_icon.svg";
import ButtonHover from "../../images/hover_button_new_icon.svg";
import TableIcon from "../../images/default_table_tabs_new_icon.svg";
import TableIconHover from "../../images/hover_table_tabs_new_icon.svg";
import TabIcon from "../../images/BlockTabsDefault.svg";
import TabIconHover from "../../images/BlockTabsHover.svg";
import {
  getFontlist,
  getVeevaLinkedModulesListByid,
  updateModuleCardsinEditor,
} from "../../services/apis";
import { cssQuotedAttr, syncAllCanvasSymbolsFromRelatedClaimsData } from "./claimEditorUsage";
import Structure from "../../images/default-structure-new-icon.svg";
import InActiveFormIcon from "../../images/default_forms_new_icon.svg";
import ImageIconDefault from "../../images/default_image_new_icon.svg";
import ActiveFormHover from "../../images/active_forms_new_icon.svg";
import TextIcon from "../../images/default_text_new_icon.svg";
import DivBlockIcon from "../../images/default_div_block_new_icon.svg";
import InActivePopUpIcon from "../../images/customPopup/InActivePopUpBlockIcon.svg";
import ActivePopUpIcon from "../../images/customPopup/ActivePopUpBlockIcon.svg";
import { filterCssObjForPerDimension } from "./responsiveCssManager.js";

export const EditorOnLoad = ({
  codeEditor,
  setLoading,
  editor,
  setVideoSelected,
  setUploadFont,
  appData,
  setOpenDocumentModal,
  setState,
  selectedItem,
  storageObjRef,
  currentSlideRef,
  relatedClaimsDataRef,
}) => {
  /** Align canvas <sup claim-id> with slide-level relatedClaimsData after each project load (all dimensions). */
  editor.on("load", () => {
    requestAnimationFrame(() => {
      try {
        const rows = relatedClaimsDataRef?.current;
        if (!rows?.length || !editor?.getWrapper?.()) return;
        syncAllCanvasSymbolsFromRelatedClaimsData(editor, rows, null);
      } catch (_) {}
    });
  });

  // let cssScript = `body{ width:1024px; height:768px;} [data-slide-id]{cursor:pointer}.tab{cursor:pointer}`
  // const fontUploadTypography = () => {
  //   const fontSize = document.querySelector(".gjs-sm-property__font-size");
  //   const eleImg = document.createElement("div");
  //   const fontUploadImg = document.createElement("img");
  //   fontUploadImg.addEventListener("click", function () {
  //     setUploadFont(true);
  //   });
  //   fontUploadImg.title = "Upload Font";
  //   fontUploadImg.src = FontUploadIcon;
  //   eleImg.classList.add("fontUploadStyle");
  //   eleImg.append(fontUploadImg);
  //   document.querySelector(".gjs-sm-property__font-family").style.width = "82%";
  //   fontSize.insertAdjacentElement("beforebegin", eleImg);
  // };

  const fontList = () => {
    document.querySelector(".gjs-sm-property__font-family").style.width =
      "100%";
    document.querySelector(".gjs-sm-property__font-family").style.paddingRight =
      "0px";
    let cardDataID = appData?.deckId?._id;
    getFontlist(cardDataID, (response, err, errCode) => {
      if (err) {
        // toast.error("");
      } else {
        //parse and save
        const data = response.data.response;
        const allFontsAvailable = [
          ...data.deckFonts,
          ...(appData?.deckId?.deck_shared_assets?.fonts || []),
        ];
        const fontFamilyadded = allFontsAvailable.map((font) => ({
          value: font?.name?.split(".")[0],
          name: font?.name?.split(".")[0],
        }));
        const cssString = editor.getCss();
        const existingFontUrls = new Set(
          [...cssString.matchAll(/@font-face\s*\{[^}]*src\s*:\s*url\(["']?([^"')]+)["']?\)[^}]*\}/gi)]
            .map((match) => match[1]),
        );
        const uniqueFonts = allFontsAvailable.filter((font, index, self) => {
          const fontUrl = font?.link;
          return fontUrl && self.findIndex((item) => item?.link === fontUrl) === index;
        });

        uniqueFonts.forEach((font) => {
          const fontUrl = font?.link;
          if (!fontUrl || existingFontUrls.has(fontUrl)) {
            return;
          }

          const fontCss = `@font-face{font-family:"${font?.name?.split(".")[0]}"; src:url("${fontUrl}");}`;
          editor.Css.addRules(fontCss);
          existingFontUrls.add(fontUrl);
        });
        //setFontlistAdded([...fontFamilyadded]);
        const fontlist = editor.StyleManager.getProperty(
          "typography",
          "font-family",
        );
        const defaultFamily = [
          { value: "inherit", name: "Inherit" },
          {
            value: "'Calibri', sans-serif",
            name: "Calibri",
          },
          /* { value: "'Oswald', sans-serif", name: "Oswald" }, */
          // {
          //   value: "Helvetica Neue, Helvetica, Arial,sans-serif",
          //   name: "Helvetica",
          // },
          { value: "'Times New Roman', serif", name: "Times New Roman" },
          { value: "Arial, sans-serif", name: "Arial" },
          { value: "Tahoma, sans-serif", name: "Tahoma" },
          {
            value: "Verdana, Geneva, sans-serif",
            name: "Verdana",
          },
          {
            value: "'Courier New', monospace",
            name: "Courier New",
          },
          { value: "'Lato', sans-serif", name: "Lato" },
          {
            value: "'Open Sans', sans-serif",
            name: "Open Sans",
          },
          {
            value: "'Montserrat', sans-serif",
            name: "Montserrat",
          },
        ];
        fontlist.set("options", [...defaultFamily, ...fontFamilyadded]);
      }
    });
  };

  /* const commonHtmlPropertyHide = () => {
                const commonHtmlDiv = document.querySelector(".gjs-sm-sector__common_content");
        console.log("selector", commonHtmlDiv)
        commonHtmlDiv.firstElementChild.classList.remove("d-block");
        commonHtmlDiv.firstElementChild.classList.add("d-none");
        commonHtmlDiv.lastElementChild.firstElementChild.firstElementChild.classList.add("d-none")
      }; */

  // editor.on('asset:upload:end', () => {
  //   const selected = editor.getSelected();
  //   console.log('ggg33')
  //   if (
  //     selected &&
  //     selected.is('image') &&
  //     !selected.getAttributes().src.includes('placeholder')
  //   ) {
  //     selected.addStyle({
  //       width: 'auto',
  //       height: 'auto'
  //     });
  //   }
  // });
  // editor.on('canvas:drop', (data) => {
  //   const dt = data.dataTransfer;
  //   if (dt && dt.files.length) {
  //     const file = dt.files[0];
  //     const reader = new FileReader();

  //     reader.onload = (event) => {
  //       const base64 = event.target.result;
  //       console.log(dt, 'jjj', base64)

  //       // Create image component
  //       editor.DomComponents.addComponent({
  //         type: 'image',
  //         src: base64,
  //       });
  //     };

  //     reader.readAsDataURL(file);
  //   }
  // });

 
  editor.on("load", async function () {
    /* const consolidatedData = await initializeDeck();
    editor.on("component:remove", async (component) => {
      if (consolidatedData) {
        const currentModules =
          consolidatedData?.length > 0
            ? consolidatedData
            : appData?.deckId?.selected_module_data ?? [];

        // ✅ Remove parent + children in one go
        let updatedModules = currentModules;
        const id = component.getAttributes()["data-content-id"];
        if (!id) return;
        appData.setDeckId((prev) => {
          const updatedModules = updateUsedState(
            prev.selected_module_data ?? [],
            id,
            "remove",
          );

          // Fire & forget DB update
          updateDBDeckContent(appData.deckId._id, 
          updatedModules);

          return {
            ...prev,
            selected_module_data: updatedModules,
            from: "editor",
          };
        });
      }
    }); */
    //setupEditor();
    editor?.on("component:remove:before", function (elem) {
      /* if (elem.getAttributes()["data-content-id"]) {
        const id = elem.getAttributes()["data-content-id"];
        const exist = updateUsedState(appData?.deckId?.selected_module_data, id, 'remove'); //consolidatedData.map((list) => list.id == id ? { ...list, used: false } : list);
        appData.setDeckId({
          ...appData.deckId,
          selected_module_data: exist,
          from: "editor",
        });
      } */
      //
      const allComps = editor?.getWrapper();
      if (elem.getAttributes()["related-claim"]) {
        if (!allComps || typeof allComps.find !== "function") {
          return false;
        }
        
        // Keep editable: true so toolbar appears, but prevent content editing via contenteditable and event handlers
        elem.set({
          editable: true, // Keep editable so inline toolbar can appear
          selectable: true, // Allows selection for styling via inline toolbar
        });
        
        // Note: Event handlers for preventing text input will be set up in rte:enable handler
        // This allows the toolbar to work properly while still preventing content editing
        
        const claimParentOnEditor = allComps?.find(`[parent-claim]`);
        let symbolElements = "";
        for (var i = 0; i < claimParentOnEditor.length; i++) {
          symbolElements = claimParentOnEditor[i]?.find("sup");
          // Keep parent-claim editable for toolbar, but prevent content editing
          claimParentOnEditor[i].set({ editable: true });
        }

        if (symbolElements.length > 0) {
          symbolElements.forEach((symbolElement) => {
            if (
              elem.getAttributes()["related-claim"] ===
              symbolElement.getAttributes()["claim-id"]
            )
              symbolElement.setStyle(
                { display: "none" },
                { avoidStore: false },
              );
          });
        }

        // Keep parent-claim elements editable for toolbar functionality
        // Content editing is prevented via contenteditable and event handlers
        for (var i = 0; i < claimParentOnEditor.length; i++) {
          claimParentOnEditor[i].set({ editable: true });
        }
      } else if (elem.getAttributes()["parent-claim"]) {
        // Keep editable: true so toolbar appears, but prevent content editing via contenteditable and event handlers
        elem.set({
          editable: true, // Keep editable so inline toolbar can appear
          selectable: true, // Allows selection for styling via inline toolbar
        });
        
        // Note: Event handlers for preventing text input will be set up in rte:enable handler
        // This allows the toolbar to work properly while still preventing content editing
        
        const claimParentOnEditor = allComps?.find(
          cssQuotedAttr("parent-claim", elem.getAttributes()["parent-claim"]),
        );
        if (elem.getAttributes()["parent-claim"]) {
          let claimRelatedOnEditor = "";
          let symbolElements = "";
          for (var i = 0; i < claimParentOnEditor.length; i++) {
            symbolElements = claimParentOnEditor[i]?.find("sup");
          }

          if (symbolElements.length > 0) {
            symbolElements.forEach((symbolElement) => {
              claimRelatedOnEditor = allComps?.find(
                cssQuotedAttr(
                  "related-claim",
                  symbolElement.getAttributes()["claim-id"],
                ),
              );
              if (claimRelatedOnEditor.length > 0) {
                for (var i = 0; i < claimRelatedOnEditor.length; i++) {
                  claimRelatedOnEditor[i].remove();
                }
              }
            });
          }
        }
      }
    });
    //
    /*  const doc = editor.Canvas.getDocument();

  doc.addEventListener('keydown', (e) => {
    if (e.key !== 'Backspace' && e.key !== 'Delete') return;

    const selection = doc.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    let node = range.startContainer;

    // If text node, move to parent element
    if (node.nodeType === 3) node = node.parentElement;

    // Protect first child against Backspace
    if (e.key === 'Backspace') {
      if (node.parentNode && node.parentNode.firstChild === node) {
        e.preventDefault();
        return;
      }
    }

    // Protect last child against Delete
    if (e.key === 'Delete') {
      if (node.parentNode && node.parentNode.lastChild === node) {
        e.preventDefault();
        return;
      }
    }
  }); */
    //end
    editor.Canvas.getBody().addEventListener("click", (e) => {
      const select = editor.getSelected();
      if (!select) return;
      const style = select.getStyle();
      let transform = style.transform || "";
      transform = transform.replace(/\(\s*\)/g, "").trim();
      select.setStyle({
        ...style,
        transform: transform,
      });
    });
    window.editor = editor; // this is done for drag mode.

    // editor.DomComponents.addType('image', {
    //   model: {
    //     defaults: {
    //       tagName: 'img',
    //       attributes: { src: '' },
    //       // style: {
    //       //   width: '450px',
    //       //   height: '450px',
    //       //   maxWidth: 'auto',
    //       //   maxHeight: 'auto'
    //       // },

    //       resizable: false, // Default: not resizable until checkbox is checked
    //       traits: [
    //         {
    //           type: 'text',
    //           name: 'src',
    //           label: 'Image URL'
    //         },
    //         {
    //           type: 'checkbox',
    //           name: 'lockAspectRatio',
    //           // name: 'keepAspect',
    //           label: 'Lock Aspect Ratio',
    //           changeProp: 1
    //         }
    //       ],
    //     },

    //     init() {
    //       this.listenTo(this, 'change:lockAspectRatio', this.toggleResizable);
    //       this.addLockIconToToolbar();
    //     },

    //     addLockIconToToolbar() {
    //       const toolbar = this.get('toolbar') || [];
    //       const hasLockIcon = toolbar.some(t => t.command === 'toggle-aspect');
    //         if (!hasLockIcon) {
    //           const lockBtn = {
    //             id: 'lock-btn',
    //             type: 'button',       // important
    //             command: 'toggle-aspect',
    //             attributes: {
    //               class: 'gjs-toolbar-item',
    //               title: 'Lock Aspect Ratio'
    //             },
    //             label: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    //               <path d="M4.20517 13.332H11.7948C11.8547 13.332 11.9039 13.3128 11.9423 13.2744C11.9808 13.2359 12 13.1868 12 13.1269V6.87053C12 6.81064 11.9808 6.76148 11.9423 6.72303C11.9039 6.68459 11.8547 6.66536 11.7948 6.66536H4.20517C4.14528 6.66536 4.09611 6.68459 4.05767 6.72303C4.01922 6.76148 4 6.81064 4 6.87053V13.1269C4 13.1868 4.01922 13.2359 4.05767 13.2744C4.09611 13.3128 4.14528 13.332 4.20517 13.332ZM8 11.1654C8.32389 11.1654 8.59933 11.0519 8.82633 10.825C9.05322 10.598 9.16667 10.3226 9.16667 9.9987C9.16667 9.67481 9.05322 9.39937 8.82633 9.17237C8.59933 8.94548 8.32389 8.83203 8 8.83203C7.67611 8.83203 7.40067 8.94548 7.17367 9.17237C6.94678 9.39937 6.83333 9.67481 6.83333 9.9987C6.83333 10.3226 6.94678 10.598 7.17367 10.825C7.40067 11.0519 7.67611 11.1654 8 11.1654ZM4.20517 14.332C3.87272 14.332 3.58872 14.2143 3.35317 13.9789C3.11772 13.7433 3 13.4593 3 13.1269V6.87053C3 6.53809 3.11772 6.25409 3.35317 6.01853C3.58872 5.78309 3.87272 5.66536 4.20517 5.66536H9V4.33203C9 3.49959 9.29189 2.79148 9.87567 2.2077C10.4594 1.62392 11.1676 1.33203 12 1.33203C12.8324 1.33203 13.5406 1.62392 14.1243 2.2077C14.7081 2.79148 15 3.49959 15 4.33203H14C14 3.77648 13.8056 3.30425 13.4167 2.91536C13.0278 2.52648 12.5556 2.33203 12 2.33203C11.4444 2.33203 10.9722 2.52648 10.5833 2.91536C10.1944 3.30425 10 3.77648 10 4.33203V5.66536H11.7948C12.1273 5.66536 12.4113 5.78309 12.6468 6.01853C12.8823 6.25409 13 6.53809 13 6.87053V13.1269C13 13.4593 12.8823 13.7433 12.6468 13.9789C12.4113 14.2143 12.1273 14.332 11.7948 14.332H4.20517Z" fill="white"/>
    //               </svg>`
    //           };

    //           this.set('toolbar', [lockBtn, ...toolbar]);
    //         }
    //     },
    //     toggleResizable() {
    //       // const toolbar = this.get('toolbar') || [];
    //       // const hasLockIcon = toolbar.some(t => t.command === 'toggle-aspect');
    //       const isLocked = this.get('lockAspectRatio');
    //       // console.log(isLocked, 'sdf');
    //       const toolbar = this.get('toolbar').map(item => {
    //         if (item.command === 'toggle-aspect') {
    //             console.log(item, 'item')
    //             return {
    //               ...item,
    //               label: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                   <path d="M4.20517 5.66536H10V4.33203C10 3.77648 9.80556 3.30425 9.41667 2.91536C9.02778 2.52648 8.55556 2.33203 8 2.33203C7.44444 2.33203 6.97222 2.52648 6.58333 2.91536C6.19444 3.30425 6 3.77648 6 4.33203H5C5 3.49959 5.29189 2.79148 5.87567 2.2077C6.45944 1.62392 7.16756 1.33203 8 1.33203C8.83244 1.33203 9.54056 1.62392 10.1243 2.2077C10.7081 2.79148 11 3.49959 11 4.33203V5.66536H11.7948C12.1273 5.66536 12.4113 5.78309 12.6468 6.01853C12.8823 6.25409 13 6.53809 13 6.87053V13.1269C13 13.4593 12.8823 13.7433 12.6468 13.9789C12.4113 14.2143 12.1273 14.332 11.7948 14.332H4.20517C3.87272 14.332 3.58872 14.2143 3.35317 13.9789C3.11772 13.7433 3 13.4593 3 13.1269V6.87053C3 6.53809 3.11772 6.25409 3.35317 6.01853C3.58872 5.78309 3.87272 5.66536 4.20517 5.66536ZM4.20517 13.332H11.7948C11.8547 13.332 11.9039 13.3128 11.9423 13.2744C11.9808 13.2359 12 13.1868 12 13.1269V6.87053C12 6.81064 11.9808 6.76148 11.9423 6.72303C11.9039 6.68459 11.8547 6.66536 11.7948 6.66536H4.20517C4.14528 6.66536 4.09611 6.68459 4.05767 6.72303C4.01922 6.76148 4 6.81064 4 6.87053V13.1269C4 13.1868 4.01922 13.2359 4.05767 13.2744C4.09611 13.3128 4.14528 13.332 4.20517 13.332ZM8 11.1654C8.32389 11.1654 8.59933 11.0519 8.82633 10.825C9.05322 10.598 9.16667 10.3226 9.16667 9.9987C9.16667 9.67481 9.05322 9.39937 8.82633 9.17237C8.59933 8.94548 8.32389 8.83203 8 8.83203C7.67611 8.83203 7.40067 8.94548 7.17367 9.17237C6.94678 9.39937 6.83333 9.67481 6.83333 9.9987C6.83333 10.3226 6.94678 10.598 7.17367 10.825C7.40067 11.0519 7.67611 11.1654 8 11.1654Z" fill="white"/>
    //                 </svg>`
    //             };
    //           }
    //           return item;
    //         });
    //         this.set('toolbar', toolbar);
    //         console.log(toolbar, 'tool')
    //       if (isLocked) {
    //         this.set('resizable', {
    //           tl: 1, tc: 0, tr: 1,
    //           cl: 0, cr: 0,
    //           bl: 1, bc: 0,
    //           br: 1,
    //           aspectRatio: true,
    //         });
    //       } else {
    //         // this.set('resizable', false);
    //         this.set('resizable', {
    //           tl: 1, // top-left
    //           tc: 1, // top-center
    //           tr: 1, // top-right
    //           cl: 1, // center-left
    //           cr: 1, // center-right
    //           bl: 1, // bottom-left
    //           bc: 1, // bottom-center
    //           br: 1,
    //         });
    //         const toolbar = this.get('toolbar').map(item => {
    //         if (item.command === 'toggle-aspect') {
    //             console.log(item, 'item')
    //             return {
    //               ...item,
    //               label: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    //               <path d="M4.20517 13.332H11.7948C11.8547 13.332 11.9039 13.3128 11.9423 13.2744C11.9808 13.2359 12 13.1868 12 13.1269V6.87053C12 6.81064 11.9808 6.76148 11.9423 6.72303C11.9039 6.68459 11.8547 6.66536 11.7948 6.66536H4.20517C4.14528 6.66536 4.09611 6.68459 4.05767 6.72303C4.01922 6.76148 4 6.81064 4 6.87053V13.1269C4 13.1868 4.01922 13.2359 4.05767 13.2744C4.09611 13.3128 4.14528 13.332 4.20517 13.332ZM8 11.1654C8.32389 11.1654 8.59933 11.0519 8.82633 10.825C9.05322 10.598 9.16667 10.3226 9.16667 9.9987C9.16667 9.67481 9.05322 9.39937 8.82633 9.17237C8.59933 8.94548 8.32389 8.83203 8 8.83203C7.67611 8.83203 7.40067 8.94548 7.17367 9.17237C6.94678 9.39937 6.83333 9.67481 6.83333 9.9987C6.83333 10.3226 6.94678 10.598 7.17367 10.825C7.40067 11.0519 7.67611 11.1654 8 11.1654ZM4.20517 14.332C3.87272 14.332 3.58872 14.2143 3.35317 13.9789C3.11772 13.7433 3 13.4593 3 13.1269V6.87053C3 6.53809 3.11772 6.25409 3.35317 6.01853C3.58872 5.78309 3.87272 5.66536 4.20517 5.66536H9V4.33203C9 3.49959 9.29189 2.79148 9.87567 2.2077C10.4594 1.62392 11.1676 1.33203 12 1.33203C12.8324 1.33203 13.5406 1.62392 14.1243 2.2077C14.7081 2.79148 15 3.49959 15 4.33203H14C14 3.77648 13.8056 3.30425 13.4167 2.91536C13.0278 2.52648 12.5556 2.33203 12 2.33203C11.4444 2.33203 10.9722 2.52648 10.5833 2.91536C10.1944 3.30425 10 3.77648 10 4.33203V5.66536H11.7948C12.1273 5.66536 12.4113 5.78309 12.6468 6.01853C12.8823 6.25409 13 6.53809 13 6.87053V13.1269C13 13.4593 12.8823 13.7433 12.6468 13.9789C12.4113 14.2143 12.1273 14.332 11.7948 14.332H4.20517Z" fill="white"/>
    //               </svg>`
    //             };
    //           }
    //           return item;
    //         });
    //         this.set('toolbar', toolbar);
    //       }
    //     }
    //   }
    // });

    // editor.on('asset:add', (asset) => {
    //   setTimeout(() => {
    //     const selected = editor.getSelected();
    //     if (
    //       selected &&
    //       selected.is('image') &&
    //       !selected.getAttributes()['data-placeholder']
    //     ) {
    //       selected.addStyle({
    //         width: 'auto',
    //         height: 'auto'
    //       });

    //       // Clean any fixed dimensions if they exist
    //       selected.removeStyle('width');
    //       selected.removeStyle('height');
    //     }
    //   }, 100);
    // });
    // // Command for toggling aspect ratio via toolbar button
    // editor.Commands.add('toggle-aspect', {
    //   run(ed, sender) {
    //     const cmp = ed.getSelected();
    //     if (!cmp) return;

    //     const keep = !cmp.get('keepAspect');
    //     if (keep) {
    //       cmp.set('resizable', {
    //         ratioDefault: true,
    //         tl: 0, tr: 0, bl: 0, br: 1
    //       });
    //     } else {
    //       cmp.set('resizable', {
    //         ratioDefault: false,
    //         tl: 0, tr: 0, bl: 0, br: 1
    //       });
    //     }
    //     // const resizable = cmp.get('resizable') || {};
    //     // // const keep = !resizable.ratioDefault;

    //     // cmp.set('resizable', { ...resizable, ratioDefault: keep });

    //     // Sync trait with toolbar
    //     cmp.set('keepAspect', keep);
    //     // Update button active state
    //     sender.set('active', keep);
    //   }
    // });

    if (
      document
        .querySelector(".editor-wrapper-tab-content")
        ?.getBoundingClientRect().width > 390
    ) {
      const ab = document.getElementsByClassName("gjs-block-categories")[0];
      ab.classList.add("expand-column");
    }

    customTraits(editor, setOpenDocumentModal);
    customTextBlock(editor);
    customExtraBlock(editor);
    customLinkBlock(editor);
    customImageBlock(editor);
    customTableBlock(editor);
    customPopupBlock(editor);
    // commonHtmlPropertyHide(); //chngs made for commonhyml
    // Hiding due to issue 2032, 2033
    // fontUploadTypography(editor);
    const PopupHover =
      document.querySelector(".popup-block")?.parentNode?.parentNode;
    PopupHover?.setAttribute("id", "popup-block-div");
    const PopupCloseHover =
      document.querySelector(".popup-close-block")?.parentNode?.parentNode;
    PopupCloseHover.setAttribute("id", "popup-close-block-div");
    const PopupTriggerHover = document.querySelector(".popup-trigger-block")
      ?.parentNode?.parentNode;
    PopupTriggerHover.setAttribute("id", "popup-trigger-block-div");
    fontList(editor);
    editor?.getWrapper()?.set("stylable", false);
    // editor.select(editor.DomComponents.getComponents().at(0));
    // editor.addStyle(

    // );
    // console.log("comp wrapper", editor.DomComponents.getComponents().at(0));
    const wrapperDiv = editor?.DomComponents?.getComponents()?.at(0);
    if (
      editor?.DomComponents?.getComponents()?.at(0)?.ccid === "wrapper" ||
      JSON.stringify(currentSlideRef?.current?.child) !== "{}"
    ) {
      wrapperDiv?.set({ removable: false, copyable: false, selectable: true });

      if (codeEditor) {
        let wrap = wrapperDiv?.getStyle();

        wrapperDiv?.setStyle({
          ...wrap,

          width: "1024px",
          height: "768px",
        });
        // editor.refresh();
        setCompStyles(appData, storageObjRef, "dim_1024*768", wrapperDiv);
      }
      if (!codeEditor && selectedItem === "dim_2048*1536") {
        let wrap = wrapperDiv?.getStyle();

        wrapperDiv.setStyle({
          ...wrap,

          width: "2048px",
          height: "1536px",
        });
        setCompStyles(appData, storageObjRef, "dim_2048*1536", wrapperDiv);
        editor.refresh();
      } else if (!codeEditor && selectedItem === "dim_2388*1668") {
        let wrap = wrapperDiv?.getStyle();

        wrapperDiv?.setStyle({
          ...wrap,
          width: "2388px",
          height: "1668px",
        });
        editor.refresh();
        // console.log(storageObjRef, "sriPada")

        setCompStyles(appData, storageObjRef, "dim_2388*1668", wrapperDiv);
        //  if (appData.deckId.default_aspect_ratio !=="ratio_16_9" &&  cssScript.length<(storageObjRef.current["ratio_16_9"]?.css.length)){
        //   editor.setStyle(storageObjRef.current["ratio_16_9"]?.css)
        //   debugger
        //  }
      } else if (!codeEditor && selectedItem === "dim_2752*2064") {
        let wrap = wrapperDiv?.getStyle();

        wrapperDiv?.setStyle({
          ...wrap,

          width: "2752px",
          height: "2064px",
        });
        editor.refresh();
        setCompStyles(appData, storageObjRef, "dim_2752*2064", wrapperDiv);

        // setStyles(appData, storageObjRef, "ratio_4_3")
        // if (storageObjRef.current["ratio_4_3"] && cssScript.length < (storageObjRef.current["ratio_4_3"]?.css.length)){
        //   editor.setStyle(storageObjRef.current["ratio_4_3"]?.css)
        //
        // }
      } else if (!codeEditor && selectedItem === "dim_1024*768") {
        let wrap = wrapperDiv?.getStyle();

        wrapperDiv?.setStyle({
          ...wrap,

          width: "1024px",
          height: "768px",
        });
        editor.refresh();
        setCompStyles(appData, storageObjRef, "dim_1024*768", wrapperDiv);

        // setStyles(appData, storageObjRef, "ratio_4_3")
        // if (storageObjRef.current["ratio_4_3"] && cssScript.length < (storageObjRef.current["ratio_4_3"]?.css.length)){
        //   editor.setStyle(storageObjRef.current["ratio_4_3"]?.css)
        //
        // }
      }
      //  if (selectedItem==="ratio_59_41"){
      //     let wrap = wrapperDiv.getStyle();

      //     wrapperDiv.setStyle({
      //     ...wrap,

      //       width: "2360px",
      //       height: "1640px",
      //     });
      //     setCompStyles(appData, storageObjRef, "ratio_59_41", wrapperDiv)
      //     editor.refresh();

      //  } else if (selectedItem==="ratio_16_9"){

      //     let wrap = wrapperDiv.getStyle();

      //     wrapperDiv.setStyle({
      //       ...wrap,
      //       width: "1920px",
      //       height: "1080px",
      //     });
      //     editor.refresh();
      //     console.log(storageObjRef,"sriPada")

      //    setCompStyles(appData, storageObjRef, "ratio_16_9", wrapperDiv)
      // //  if (appData.deckId.default_aspect_ratio !=="ratio_16_9" &&  cssScript.length<(storageObjRef.current["ratio_16_9"]?.css.length)){
      // //   editor.setStyle(storageObjRef.current["ratio_16_9"]?.css)
      // //   debugger
      // //  }
      //  }
      //  else if(selectedItem==="ratio_4_3"){

      //     let wrap = wrapperDiv.getStyle();

      //     wrapperDiv.setStyle({
      //       ...wrap,

      //       width: "1024px",
      //       height: "768px",
      //     });
      //     editor.refresh();
      //     setCompStyles(appData, storageObjRef, "ratio_4_3", wrapperDiv)

      //    // setStyles(appData, storageObjRef, "ratio_4_3")
      //     // if (storageObjRef.current["ratio_4_3"] && cssScript.length < (storageObjRef.current["ratio_4_3"]?.css.length)){
      //     //   editor.setStyle(storageObjRef.current["ratio_4_3"]?.css)
      //     //
      //     // }
      //  }

      // making editor droppable false , as all components should be wrapped inside wrapper **start**
      // editor.getWrapper().set({
      //   droppable: false,
      // });

      // wrapperDiv.setStyle({
      //   position: "absolute",
      //   top: "0",
      //   left: "0",
      //   width: "1024px",
      //   height: "768px",
      // });
      // making editor droppable false , as all components should be wrapped inside wrapper **End**
    }
    // editor.selectAdd(editor.getWrapper());
    editor.runCommand("sw-visibility");
    // Apply canvas sizing after iframe is fully loaded
    const applyCanvasSizing = () => {
      try {
        const canvasDoc = editor?.Canvas?.getDocument();
        const head = canvasDoc?.head;

        if (!head) {
          // console.log("Canvas document head not found, retrying...");
          setTimeout(applyCanvasSizing, 100);
          return;
        }

        // console.log("Applying canvas sizing for:", selectedItem);

        // Get dynamic dimensions
        const width =
          selectedItem === "dim_2048*1536"
            ? "2048px"
            : selectedItem === "dim_2388*1668"
            ? "2388px"
            : selectedItem === "dim_2752*2064"
            ? "2752px"
            : "1024px";
        const height =
          selectedItem === "dim_2048*1536"
            ? "1536px"
            : selectedItem === "dim_2388*1668"
            ? "1668px"
            : selectedItem === "dim_2752*2064"
            ? "2064px"
            : "768px";

        // Remove existing canvas sizing styles
        const existingStyle = canvasDoc.getElementById("canvas-sizing-styles");
        if (existingStyle) existingStyle.remove();

        // Add new sizing styles
        head.insertAdjacentHTML(
          "beforeend",
          `<style id="canvas-sizing-styles">
            @import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');
            /* Dynamic canvas sizing */
            body { 
              width: ${width} !important; 
              height: ${height} !important; 
              margin: 0 !important; 
              background-color: #fff !important;
            }
            
            /* Target the iframe itself */
            .gjs-frame {
              width: ${width} !important; 
              height: ${height} !important;
            }
          </style>`,
        );

        // console.log(`Canvas sizing applied: ${width} x ${height}`);

        // Also try to apply sizing directly to iframe element
        const frameEl = editor.Canvas.getFrameEl();
        if (frameEl) {
          frameEl.style.width = width;
          frameEl.style.height = height;
          // console.log("Direct iframe styling applied");
        }
      } catch (error) {
        console.error("Error applying canvas sizing:", error);
      }
    };

    // Apply sizing after a short delay to ensure iframe is ready
    setTimeout(applyCanvasSizing, 200);
    // const otherBlock = document?.querySelector(".gjs-blocks-c");
    // otherBlock?.classList?.add("d-none");
    const showStructure = document?.querySelector(
      ".gjs-blocks-no-cat .gjs-blocks-c",
    )?.firstChild;
    showStructure.style.cursor = "pointer";
    showStructure.classList.add("active-block");
    const hideFormsBlocks = document?.querySelector(".gjs-block-categories")
      ?.childNodes[1];
    const textAreaElem = hideFormsBlocks.lastElementChild.children[2];
    textAreaElem.setAttribute("title", "Text Area");
    const dropdownElem = hideFormsBlocks.lastElementChild.children[3];
    dropdownElem?.setAttribute("title", "Dropdown");

    hideFormsBlocks.style.cursor = "pointer";
    hideFormsBlocks.classList.add("d-none", "forms-field-block");
    // const hideStructure = document.querySelector(
    //   ".gjs-blocks-no-cat .gjs-blocks-c"
    // ).lastElementChild;
    // hideStructure.getElementsByClassName("gjs-block__media")[0].lastChild.src =
    //   InActiveFormIcon;
    // hideStructure.classList.add("forms-inActive-block");
    // hideStructure.classList.remove("forms-active-block");
    //Extra block starts
    const extraBlock = document?.querySelector(
      ".gjs-blocks-no-cat .gjs-blocks-c",
    )?.lastElementChild;
    if (showStructure) {
      showStructure.style.cursor = "pointer";
      showStructure.classList.add("active-block");
    }
    if (extraBlock) {
      extraBlock.style.cursor = "pointer";
    }
    // const inActiveExtra = document?.querySelector(
    //   ".gjs-blocks-no-cat .gjs-blocks-c"
    // )?.childNodes[8];
    // if (inActiveExtra) {
    //   inActiveExtra.getElementsByClassName(
    //     "gjs-block__media"
    //   )[0].lastChild.src = InActiveExtraIcon;
    //   inActiveExtra.classList.remove("forms-active-block");
    //   inActiveExtra.classList.add("extra-block");
    //   console.log('5555')
    // }
    const textBlock = document?.querySelector(
      ".gjs-block-categories",
    )?.lastElementChild;

    if (textBlock) {
      textBlock?.classList?.add("d-none");
      textBlock?.classList?.remove("d-block");
    }

    const imgHoverObj = {
      structure: StructureHover,
      tabs: TabIconHover,
      link: ButtonHover,
      table: TableIconHover,
      video: VideoIconHover,
      image: ImageIconHover,
      text: TextIconHover,
      forms: ActiveFormHover,
      extra: ActiveExtraHover,
      popup: ActivePopUpIcon,
    };
    const imgLeaveObj = {
      structure: Structure,
      tabs: TabIcon,
      link: ButtonDefault,
      table: TableIcon,
      video: VideoIcon,
      image: ImageIconDefault,
      text: TextIcon,
      forms: InActiveFormIcon,
      extra: InActiveExtraIcon,
      popup: InActivePopUpIcon,
    };
    const childNodesBlock = document?.querySelector(
      ".gjs-blocks-no-cat .gjs-blocks-c",
    ).childNodes;
    childNodesBlock.forEach((blockElem) => {
      blockElem.addEventListener("mouseover", function (el) {
        const imgTag =
          blockElem.getElementsByClassName("gjs-block__media")[0].firstChild;

        if (imgHoverObj.hasOwnProperty(imgTag.alt)) {
          imgTag.style.height = "52px";
          imgTag.style.width = "54px";
          if (!blockElem.classList.contains("active-block")) {
            blockElem.getElementsByClassName(
              "gjs-block__media",
            )[0].firstChild.src = imgHoverObj[imgTag.alt];
          }
        }
        // console.log(
        //   blockElem.getElementsByClassName("gjs-block__media")[0].firstChild
        // );
      });
      blockElem.addEventListener("mouseout", function (el) {
        const imgTag =
          blockElem.getElementsByClassName("gjs-block__media")[0].firstChild;
        if (imgLeaveObj.hasOwnProperty(imgTag.alt)) {
          if (!blockElem.classList.contains("active-block")) {
            blockElem.getElementsByClassName(
              "gjs-block__media",
            )[0].firstChild.src = imgLeaveObj[imgTag.alt];
          }
        }
        // console.log(
        //   blockElem.getElementsByClassName("gjs-block__media")[0].firstChild
        // );
      });

      // console.log(blockElem);
    });
    childNodesBlock[0].addEventListener("click", function () {
      setState(false);
    });
    childNodesBlock[1].style.cursor = "pointer";
    childNodesBlock[1].classList.add("text-block");

    // console.log("---------------", childNodesBlock);
    let removeSlide = window.localStorage.getItem("removedSlieId");
    if (removeSlide) {
      let wrapper = editor
        .getWrapper()
        .find(`[data-slide-id="${removeSlide}"]`);
      wrapper.forEach((el) => {
        if (el.attributes.attributes.hasOwnProperty("data-id")) {
          var comp = editor.getComponents();
          comp.remove(el);
        } else {
          const attr = el.getAttributes();
          delete attr["data-slide-id"];
          delete attr["ccid"];
          el.setAttributes(attr);
        }
      });
    }

    editor.Blocks.add("Div", {
      category: "Basic",
      label: "Div",

      attributes: { class: "custom-div-block" },
      media: `<img src="${DivBlockIcon}" style="width: 174px !important; height: 40px !important" class="block-div" title="Div" draggable="true"></img>`,
      content: {
        type: "Div",
        style: { display: "block", "min-width": "50px", "min-height": "50px" },
      },
    });
    const ImageHoverDiv =
      document.querySelector(".image-block")?.parentNode?.parentNode;
    ImageHoverDiv?.setAttribute("id", "imageblockdiv");
    const VideoHoverDiv =
      document.querySelector(".video-block")?.parentNode?.parentNode;
    VideoHoverDiv?.setAttribute("id", "videoblockdiv");
    const DeviderHoverDiv =
      document.querySelector(".extra-link-block")?.parentNode?.parentNode;
    DeviderHoverDiv.setAttribute("id", "extralinkblockdiv");
    const TableHoverDiv =
      document.querySelector(".table-block")?.parentNode?.parentNode;
    TableHoverDiv.setAttribute("id", "tableblockdiv");
    const TabsHoverDiv =
      document.querySelector(".tabs-block")?.parentNode?.parentNode;
    TabsHoverDiv.setAttribute("id", "tabsblockdiv");
    const HeadingHoverDiv =
      document.querySelector(".heading-block")?.parentNode?.parentNode;
    HeadingHoverDiv?.setAttribute("id", "headingblockdiv");
    const SubHeadingHoverDiv =
      document.querySelector(".sub-heading-block")?.parentNode?.parentNode;
    SubHeadingHoverDiv.setAttribute("id", "sub-headingblockdiv");
    const ParagraphHoverDiv =
      document.querySelector(".paragraph-block")?.parentNode?.parentNode;
    ParagraphHoverDiv.setAttribute("id", "paragraphblockdiv");

    [
      ".custom-structure",
      ".custom-text",
      ".custom-images",
      ".custom-table",
      ".custom-link",
      ".custom-forms",
      ".custom-extra",
      ".custom-popup",
    ].forEach((selector) => {
      const el = document.querySelector(selector);
      el?.addEventListener("click", () => {
        if (editor.getSelected()) {
          editor.select(null); // Deselect the selected component
          setVideoSelected(false);
        }
      });
    });
  });
};

const setCompStyles = (appData, storageObjRef, ratio, wrapperDiv) => {
  if (appData.deckId.default_aspect_ratio !== ratio) {
    let cssObj = storageObjRef?.current[ratio]?.cssObj || [];

    cssObj.forEach((obj) => {
      if (obj.id !== "wrapper") {
        let elem = wrapperDiv.find("#" + obj.id)[0];
        if (!elem) return;
        let elemStyle = elem?.getStyle() || {};
        const extras = filterCssObjForPerDimension(elemStyle, obj);

        elem?.setStyle({
          ...elemStyle,
          ...extras,
        });
      }
    });
  }
  //cssObj
};
